import React from 'react';
import { Button } from '@habitech/call-to-action';
import Modal from '../../common/modal/Modal';
import { ButtonContainer, ModalContent, ModalMessage, ModalTitle } from './styles';

interface ModalComponentProps {
  isOpen: boolean;
  onClose: () => void;
  type: 'confirmation' | 'success' | 'error';
  title: string;
  message: string;
  confirmText?: string;
  cancelText?: string;
  onConfirm?: () => void;
  onCancel?: () => void;
}

const ModalComponent: React.FC<ModalComponentProps> = ({
  isOpen,
  onClose,
  type,
  title,
  message,
  confirmText = 'Confirmar',
  cancelText = 'Cancelar',
  onConfirm,
  onCancel
}) => {
  if (!isOpen) return null;

  const handleConfirm = () => {
    if (onConfirm) {
      onConfirm();
    }
    onClose();
  };

  const handleCancel = () => {
    if (onCancel) {
      onCancel();
    }
    onClose();
  };


  const getButtonVariant = () => {
    switch (type) {
      case 'success':
        return 'primary';
      case 'error':
        return 'stroke';
      case 'confirmation':
        return 'primary';
      default:
        return 'primary';
    }
  };

  return (
    <Modal onClose={onClose}>
      <ModalContent>
        <ModalTitle>{title}</ModalTitle>
        <ModalMessage>{message}</ModalMessage>
        <ButtonContainer>
          {type === 'confirmation' && (
            <Button
              dataId="modal-cancel-button"
              originType="pcom"
              size="large"
              variant="stroke"
              onClick={handleCancel}
            >
              {cancelText}
            </Button>
          )}
          <Button
            dataId="modal-confirm-button"
            originType="pcom"
            size="large"
            variant={getButtonVariant()}
            onClick={handleConfirm}
          >
            {type === 'confirmation' ? confirmText : 'Aceptar'}
          </Button>
        </ButtonContainer>
      </ModalContent>
    </Modal>
  );
};

export default ModalComponent;